import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql, Link } from "gatsby"
import Box from "../base/Box"
import Text from "../base/Text"
import Button from "../base/Button"
import Heading from "../base/Heading"
import FeatureBlock from "../FeatureBlock"
import Container from "../UI/Container"
import FeatureSectionWrapper from "./latest.style"
import { SectionText, SectionHeading } from "../Section/Section"
// import { Row, Col, Card, CardTitle } from 'react-materialize';
import Card from "../Card/Card"
import { BEZVEZZE_IMG } from "../../assets/images/images"
const FeatureSection = ({
  row,
  col,
  secTitleWrapper,
  featureTitle,
  featureDescription,
  iconStyle,
  contentStyle,
  btnStyle,
}) => {
  const cards = new Array(3).fill(1)

  return (
    <FeatureSectionWrapper id="news_section">
      <Container noGutter mobileGutter className="container">
        <Box {...secTitleWrapper}>
          <SectionText content="OUR PROJECTS" />
          <SectionHeading content="Take a look at the projects we worked on" />
        </Box>
        <Box className="row" {...row}>
          <Card
            src={BEZVEZZE_IMG}
            title={"Bezvezze"}
            projectTitle={"Mobile application for iOS, Android and the web."}
            text={"Bezvezze is a dating app."}
          />
          {/* {cards.map(card => ( */}
          {/* <Card
            key={1}
            header={<CardTitle reveal image={BEZVEZZE_IMG} waves='light' />}
            title='Bezvezze'
            reveal={
              <div>
                <p>title</p>
                <p>subtitle</p>
                <p>
                  subtitle2
                  <a href='https://bezvezze.com'> https://bezvezze.com</a>.
                </p>
              </div>
            }
          >
            <h6 className='workType project-title'>text1</h6>
            <p>text2</p>
          </Card> */}
          {/* ))} */}
        </Box>
      </Container>
    </FeatureSectionWrapper>
  )
}

// FeatureSection style props
FeatureSection.propTypes = {
  secTitleWrapper: PropTypes.object,
  row: PropTypes.object,
  col: PropTypes.object,
  secHeading: PropTypes.object,
  secText: PropTypes.object,
  featureTitle: PropTypes.object,
  featureDescription: PropTypes.object,
  btnStyle: PropTypes.object,
}

// FeatureSection default style
FeatureSection.defaultProps = {
  // section header default style
  secTitleWrapper: {
    mb: ["65px", "65px", "80px", "90px", "90px"],
  },
  secHeading: {
    textAlign: "center",
    fontSize: ["20px", "24px"],
    fontWeight: "400",
    color: "#0f2137",
    letterSpacing: "-0.025em",
    mb: "0",
  },
  secText: {
    as: "span",
    display: "block",
    textAlign: "center",
    fontSize: "14px",
    letterSpacing: "0.15em",
    fontWeight: "700",
    color: "rgb(255,148,147)",
    mb: "10px",
  },
  // feature row default style
  row: {
    flexBox: true,
    flexWrap: "wrap",
  },
  // feature col default style
  col: {
    width: [1, 1 / 2, 1 / 2, 1 / 2],
  },
  // feature content default style
  contentStyle: {
    textAlign: "left",
    mt: ["30px", "30px"],
  },
  // feature title default style
  featureTitle: {
    fontSize: ["15px", "16px"],
    lineHeight: "1.5",
    fontWeight: "600",
    color: "#15172C",
    textAlign: "left",
    fontFamily: "Poppins",
    mb: "0px",
  },
  // feature description default style
  featureDescription: {
    lineHeight: ["28px", "32px", "32px", "32px", "32px"],
    mt: ["7px", "7px", "7px", "7px", "7px"],
    mb: ["7px", "7px", "7px", "7px", "7px"],
    textAlign: ["left", "left"],
    fontSize: ["15px", "16px"],
    fontWeight: "400",
    color: "#15172C",
    fontFamily: "Lato",
  },
  btnStyle: {
    lineHeight: ["28px", "32px", "32px", "32px", "32px"],
    fontSize: ["15px", "16px"],
    fontWeight: "700",
    color: "#46c2bc",
    fontFamily: "Lato",
  },
}

export default FeatureSection
